export const DELETE_COMMENT_BY_ID = 'DELETE_COMMENT_BY_ID'
export const DELETE_COMMENT_BY_ID_PENDING = 'DELETE_COMMENT_BY_ID_PENDING'
export const DELETE_COMMENT_BY_ID_FULFILLED = 'DELETE_COMMENT_BY_ID_FULFILLED'
export const DELETE_COMMENT_BY_ID_REJECTED = 'DELETE_COMMENT_BY_ID_REJECTED'
export const CLEAR_DELETE_COMMENT_BY_ID = 'CLEAR_DELETE_COMMENT_BY_ID'

export const CREATE_COMMENT = 'CREATE_COMMENT'
export const CREATE_COMMENT_PENDING = 'CREATE_COMMENT_PENDING'
export const CREATE_COMMENT_FULFILLED = 'CREATE_COMMENT_FULFILLED'
export const CREATE_COMMENT_REJECTED = 'CREATE_COMMENT_REJECTED'
export const CLEAR_CREATE_COMMENT = 'CLEAR_CREATE_COMMENT'

type CommentCandidateData = {
  current_role: string
  id: number
  name_ar: string
  name_en: string
  name_i18n: string
}

export type CommentData = {
  id: number
  text: string
  candidate: CommentCandidateData
  commenter_id: number
  organization_id: number
  job_title: string
  created_at: string
  updated_at: string
}

export type CreateCommentRequest = {
  comment: {
    text: string
    candidate_id: number
    job_id?: number
  }
}

export type CreateCommentResponse = {
  data: {
    message: string
    comment: CommentData
  }
  success: boolean
  statusCode: number
}

export type DeleteCommentResponse = {
  data: {
    message: string
  }
  success?: boolean
  statusCode?: number
}
